export default __webpack_public_path__ + "static/industry-bda5e0459b8ed30daf8c85c8a263030b.jpg";